export const config = {
  chatUrl: import.meta.env.VITE_CHAT_URL as string,
}
